import { Trans } from 'react-i18next'
import { Descendant } from 'slate'

import { IActionFormProps, VARIABLE_TEXT_FEATURE_FLAG_ALL, VariableTextFeatureFlag } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { getDefaultDescendantValue } from '@/lib/slate'
import { useForm } from '@/lib/use-form'
import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { getDataSourceKeyForComponent } from '@/shared/builder/utils/components'
import { VariableTextV2 } from '@/components/VariableTextV2/VariableTextV2'

import { ActFormWithInputOutput } from '../../action-workflows/simulations'

export default function ActFormTemporaryVariable({
  onSubmit,
  onDismiss,
  initialData,
  triggerSource,
}: IActionFormProps) {
  const { activeLayerContainer } = useActiveLayerContext()
  const { activeComponent } = useActiveLayerContext()
  const dataSourceKey = getDataSourceKeyForComponent(activeComponent?.compId || '')
  const table = dataSourceKey
    ? (activeLayerContainer?.elementSettings?.[activeComponent?.id as string]?.[dataSourceKey] ?? null)
    : null
  const activeTableId = (table as any)?.table ?? table

  const { form, onSubmit: onFormSubmit } = useForm({
    defaultValues: {
      name: initialData?.name?.value || getDefaultDescendantValue(''),
      value: initialData?.value?.value || getDefaultDescendantValue(''),
      ...(initialData || {}),
    },
    validate(data, setError) {
      // const isDefaultValue = (v: any) => {
      //   const textValue =
      //     parseVariableText(v, activeLayerClient, userEmail, language, userSpecific, activeTableId, 0)?.trim() || ''
      //   return textValue === ''
      // }
      // const isEmptyValue = !data.value || isDefaultValue(data.value)
      // const isEmptyName = !data.name || isDefaultValue(data.name)
      // setError('value', isEmptyValue ? 'Value cannot be empty' : null)
      // setError('name', isEmptyName ? 'Name cannot be empty' : null)
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('value')
  const name = form.getValues('name')

  // const valueText =
  //   parseVariableText(value, activeLayerClient, userEmail, language, userSpecific, activeTableId, 0)?.trim() || ''
  // const nameText =
  //   parseVariableText(name, activeLayerClient, userEmail, language, userSpecific, activeTableId, 0)?.trim() || ''

  let featureFlags =
    (VARIABLE_TEXT_FEATURE_FLAG_ALL &
      ~VariableTextFeatureFlag.Icon &
      ~VariableTextFeatureFlag.Image &
      ~VariableTextFeatureFlag.Column &
      ~VariableTextFeatureFlag.ColumnData) |
    VariableTextFeatureFlag.DateTime |
    VariableTextFeatureFlag.ActionOutput

  if (triggerSource === 'newsletter') {
    featureFlags = featureFlags | VariableTextFeatureFlag.NewsletterEmail
  }

  return (
    <ActFormWithInputOutput
      data={{
        value: value as Descendant[],
      }}
    >
      <div className='flex flex-col h-full md:min-w-[672px]'>
        <div className='p-4'>
          <Field>
            <Label required>Name</Label>

            <VariableTextV2
              tableId={activeTableId}
              featureFlags={featureFlags}
              value={name as Descendant[]}
              onChange={(value) => {
                form.setValues('name', value)
              }}
              options={initialData?.actionOptions}
              placeholder='Enter name'
            />
          </Field>
          <Field>
            <Label required>Value</Label>

            <VariableTextV2
              tableId={activeTableId}
              featureFlags={featureFlags}
              value={value as Descendant[]}
              onChange={(value) => {
                form.setValues('value', value)
              }}
              placeholder='Enter value'
              options={initialData?.actionOptions}
            />
          </Field>
        </div>

        <div className='px-4 py-2 border-t bdr flex justify-between items-center mt-auto'>
          <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
            <Trans>Cancel</Trans>
          </Button>
          <Button onClick={handleSubmit}>
            <Trans>Save</Trans>
          </Button>
        </div>
      </div>
    </ActFormWithInputOutput>
  )
}
